export const Step = {
  INITAL: 1,
  CURRENCY: 2,
  NOTE: 3,
  INVOICE_NUMBER: 4,
  CATEGORIES: 5,
  SUB_CATEGORIES: 6,
  COST_CENTER: 7,
  BUDGET: 8,
  VENDOR: 9,
  STATUS: 10,
  VENDOR_PAYMENT_DETAILS: 11,
} as const;
